import type { SVGProps } from 'react';

export function IconArrowUpRight(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.7}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <path d="M8 16 16 8M9.5 8H16v6.5" />
        </svg>
    );
}
